/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineAmenityDto } from './traveline-amenity-dto';
import {
    TravelineAmenityDtoFromJSON,
    TravelineAmenityDtoFromJSONTyped,
    TravelineAmenityDtoToJSON,
    TravelineAmenityDtoToJSONTyped,
} from './traveline-amenity-dto';
import type { TravelineTotalDto } from './traveline-total-dto';
import {
    TravelineTotalDtoFromJSON,
    TravelineTotalDtoFromJSONTyped,
    TravelineTotalDtoToJSON,
    TravelineTotalDtoToJSONTyped,
} from './traveline-total-dto';
import type { TravelineRoomTypeSquareDto } from './traveline-room-type-square-dto';
import {
    TravelineRoomTypeSquareDtoFromJSON,
    TravelineRoomTypeSquareDtoFromJSONTyped,
    TravelineRoomTypeSquareDtoToJSON,
    TravelineRoomTypeSquareDtoToJSONTyped,
} from './traveline-room-type-square-dto';
import type { TravelineAddressDto } from './traveline-address-dto';
import {
    TravelineAddressDtoFromJSON,
    TravelineAddressDtoFromJSONTyped,
    TravelineAddressDtoToJSON,
    TravelineAddressDtoToJSONTyped,
} from './traveline-address-dto';
import type { TravelineIncludedRoomStayServiceDto } from './traveline-included-room-stay-service-dto';
import {
    TravelineIncludedRoomStayServiceDtoFromJSON,
    TravelineIncludedRoomStayServiceDtoFromJSONTyped,
    TravelineIncludedRoomStayServiceDtoToJSON,
    TravelineIncludedRoomStayServiceDtoToJSONTyped,
} from './traveline-included-room-stay-service-dto';
import type { TravelineResourceDto } from './traveline-resource-dto';
import {
    TravelineResourceDtoFromJSON,
    TravelineResourceDtoFromJSONTyped,
    TravelineResourceDtoToJSON,
    TravelineResourceDtoToJSONTyped,
} from './traveline-resource-dto';
import type { TravelineRatePlanDto } from './traveline-rate-plan-dto';
import {
    TravelineRatePlanDtoFromJSON,
    TravelineRatePlanDtoFromJSONTyped,
    TravelineRatePlanDtoToJSON,
    TravelineRatePlanDtoToJSONTyped,
} from './traveline-rate-plan-dto';
import type { TravelineBookingStayDatesDto } from './traveline-booking-stay-dates-dto';
import {
    TravelineBookingStayDatesDtoFromJSON,
    TravelineBookingStayDatesDtoFromJSONTyped,
    TravelineBookingStayDatesDtoToJSON,
    TravelineBookingStayDatesDtoToJSONTyped,
} from './traveline-booking-stay-dates-dto';
import type { TravelineRoomTypeDto } from './traveline-room-type-dto';
import {
    TravelineRoomTypeDtoFromJSON,
    TravelineRoomTypeDtoFromJSONTyped,
    TravelineRoomTypeDtoToJSON,
    TravelineRoomTypeDtoToJSONTyped,
} from './traveline-room-type-dto';
import type { TravelineOccupancyInfoDto } from './traveline-occupancy-info-dto';
import {
    TravelineOccupancyInfoDtoFromJSON,
    TravelineOccupancyInfoDtoFromJSONTyped,
    TravelineOccupancyInfoDtoToJSON,
    TravelineOccupancyInfoDtoToJSONTyped,
} from './traveline-occupancy-info-dto';
import type { TravelinePlacementDto } from './traveline-placement-dto';
import {
    TravelinePlacementDtoFromJSON,
    TravelinePlacementDtoFromJSONTyped,
    TravelinePlacementDtoToJSON,
    TravelinePlacementDtoToJSONTyped,
} from './traveline-placement-dto';

/**
 * 
 * @export
 * @interface TravelineAdditionalRoomStayDto
 */
export interface TravelineAdditionalRoomStayDto {
    /**
     * 
     * @type {TravelineBookingStayDatesDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    stayDates: TravelineBookingStayDatesDto;
    /**
     * Property ID
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    propertyId: string;
    /**
     * 
     * @type {TravelineRoomTypeDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    roomType: TravelineRoomTypeDto;
    /**
     * 
     * @type {TravelineRatePlanDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    ratePlan: TravelineRatePlanDto;
    /**
     * Prices currency at the accommodation
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    currencyCode: string;
    /**
     * 
     * @type {TravelineTotalDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    total: TravelineTotalDto;
    /**
     * String description of accommodation options
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    fullPlacementsName: string;
    /**
     * Extra services included
     * @type {Array<TravelineIncludedRoomStayServiceDto>}
     * @memberof TravelineAdditionalRoomStayDto
     */
    includedServices?: Array<TravelineIncludedRoomStayServiceDto> | null;
    /**
     * Meal plan code
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    mealPlanCode?: string | null;
    /**
     * Room type ID
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    id: string;
    /**
     * Name
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    name: string;
    /**
     * Category code
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    categoryCode: string;
    /**
     * Category name
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    categoryName: string;
    /**
     * Accommodations entity
     * @type {Array<TravelinePlacementDto>}
     * @memberof TravelineAdditionalRoomStayDto
     */
    placements: Array<TravelinePlacementDto>;
    /**
     * Detailed description
     * @type {string}
     * @memberof TravelineAdditionalRoomStayDto
     */
    description?: string | null;
    /**
     * Room amenities
     * @type {Array<TravelineAmenityDto>}
     * @memberof TravelineAdditionalRoomStayDto
     */
    amenities?: Array<TravelineAmenityDto> | null;
    /**
     * Room images
     * @type {Array<TravelineResourceDto>}
     * @memberof TravelineAdditionalRoomStayDto
     */
    images?: Array<TravelineResourceDto> | null;
    /**
     * 
     * @type {TravelineRoomTypeSquareDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    propertySize?: TravelineRoomTypeSquareDto;
    /**
     * 
     * @type {TravelineAddressDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    address?: TravelineAddressDto;
    /**
     * 
     * @type {TravelineOccupancyInfoDto}
     * @memberof TravelineAdditionalRoomStayDto
     */
    occupancy?: TravelineOccupancyInfoDto;
    /**
     * Order in output
     * @type {number}
     * @memberof TravelineAdditionalRoomStayDto
     */
    position?: number | null;
}

/**
 * Check if a given object implements the TravelineAdditionalRoomStayDto interface.
 */
export function instanceOfTravelineAdditionalRoomStayDto(value: object): value is TravelineAdditionalRoomStayDto {
    if (!('stayDates' in value) || value['stayDates'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('roomType' in value) || value['roomType'] === undefined) return false;
    if (!('ratePlan' in value) || value['ratePlan'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('fullPlacementsName' in value) || value['fullPlacementsName'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryCode' in value) || value['categoryCode'] === undefined) return false;
    if (!('categoryName' in value) || value['categoryName'] === undefined) return false;
    if (!('placements' in value) || value['placements'] === undefined) return false;
    return true;
}

export function TravelineAdditionalRoomStayDtoFromJSON(json: any): TravelineAdditionalRoomStayDto {
    return TravelineAdditionalRoomStayDtoFromJSONTyped(json, false);
}

export function TravelineAdditionalRoomStayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineAdditionalRoomStayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'stayDates': TravelineBookingStayDatesDtoFromJSON(json['stayDates']),
        'propertyId': json['propertyId'],
        'roomType': TravelineRoomTypeDtoFromJSON(json['roomType']),
        'ratePlan': TravelineRatePlanDtoFromJSON(json['ratePlan']),
        'currencyCode': json['currencyCode'],
        'total': TravelineTotalDtoFromJSON(json['total']),
        'fullPlacementsName': json['fullPlacementsName'],
        'includedServices': json['includedServices'] == null ? undefined : ((json['includedServices'] as Array<any>).map(TravelineIncludedRoomStayServiceDtoFromJSON)),
        'mealPlanCode': json['mealPlanCode'] == null ? undefined : json['mealPlanCode'],
        'id': json['id'],
        'name': json['name'],
        'categoryCode': json['categoryCode'],
        'categoryName': json['categoryName'],
        'placements': ((json['placements'] as Array<any>).map(TravelinePlacementDtoFromJSON)),
        'description': json['description'] == null ? undefined : json['description'],
        'amenities': json['amenities'] == null ? undefined : ((json['amenities'] as Array<any>).map(TravelineAmenityDtoFromJSON)),
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(TravelineResourceDtoFromJSON)),
        'propertySize': json['propertySize'] == null ? undefined : TravelineRoomTypeSquareDtoFromJSON(json['propertySize']),
        'address': json['address'] == null ? undefined : TravelineAddressDtoFromJSON(json['address']),
        'occupancy': json['occupancy'] == null ? undefined : TravelineOccupancyInfoDtoFromJSON(json['occupancy']),
        'position': json['position'] == null ? undefined : json['position'],
    };
}

  export function TravelineAdditionalRoomStayDtoToJSON(json: any): TravelineAdditionalRoomStayDto {
      return TravelineAdditionalRoomStayDtoToJSONTyped(json, false);
  }

  export function TravelineAdditionalRoomStayDtoToJSONTyped(value?: TravelineAdditionalRoomStayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stayDates': TravelineBookingStayDatesDtoToJSON(value['stayDates']),
        'propertyId': value['propertyId'],
        'roomType': TravelineRoomTypeDtoToJSON(value['roomType']),
        'ratePlan': TravelineRatePlanDtoToJSON(value['ratePlan']),
        'currencyCode': value['currencyCode'],
        'total': TravelineTotalDtoToJSON(value['total']),
        'fullPlacementsName': value['fullPlacementsName'],
        'includedServices': value['includedServices'] == null ? undefined : ((value['includedServices'] as Array<any>).map(TravelineIncludedRoomStayServiceDtoToJSON)),
        'mealPlanCode': value['mealPlanCode'],
        'id': value['id'],
        'name': value['name'],
        'categoryCode': value['categoryCode'],
        'categoryName': value['categoryName'],
        'placements': ((value['placements'] as Array<any>).map(TravelinePlacementDtoToJSON)),
        'description': value['description'],
        'amenities': value['amenities'] == null ? undefined : ((value['amenities'] as Array<any>).map(TravelineAmenityDtoToJSON)),
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(TravelineResourceDtoToJSON)),
        'propertySize': TravelineRoomTypeSquareDtoToJSON(value['propertySize']),
        'address': TravelineAddressDtoToJSON(value['address']),
        'occupancy': TravelineOccupancyInfoDtoToJSON(value['occupancy']),
        'position': value['position'],
    };
}

